import { OfficeConstant } from '../constants';
import { RequestAction, UploadAction } from '.';

export const createOffice = data =>
  RequestAction.request(OfficeConstant.CREATE_OFFICE, {
    data,
    method: 'post',
    url: `/api/office`,
  });

export const deleteOffice = id =>
  RequestAction.request(OfficeConstant.DELETE_OFFICE, {
    method: 'delete',
    url: `/api/office/${id}`,
  });

export const editOffice = (id, data) =>
  RequestAction.request(OfficeConstant.EDIT_OFFICE, {
    data,
    method: 'put',
    url: `/api/office/${id}`,
  });

export const getOffice = id =>
  RequestAction.request(OfficeConstant.GET_OFFICE, {
    url: `/api/office/${id}`,
  });

export const getOffices = params =>
  RequestAction.request(OfficeConstant.GET_OFFICES, {
    params,
    url: '/api/office',
  }, false);

export const setOffice = payload => ({
  payload,
  type: OfficeConstant.SET_OFFICE,
});

export const setOffices = payload => ({
  payload,
  type: OfficeConstant.SET_OFFICES,
});

export const uploadLogo = files =>
  UploadAction.upload(OfficeConstant.UPLOAD_OFFICE_LOGO, files);
